import { NgModule } from '@angular/core';
import { ImageService } from './services/image-gallery.service';
import { GalleryComponent } from './components/gallery/gallery.component';
import { ViewerComponent } from './components/viewer/viewer.component';
import { FormsModule } from '@angular/forms'; // really required?
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http'; // really required ?
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    GalleryComponent,
    ViewerComponent
  ],
  providers: [
    ImageService
  ],
  exports: [
    GalleryComponent,
    ViewerComponent
  ]
})
export class ImageGalleryModule {
}
